import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './styles.less';
import * as Selectors from '../reducers/selectors';
import PicabooComponentBase from './PicabooComponentBase';

class CoverOverlayText extends PicabooComponentBase {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <div
        ref={(ref) => {
          this.coverOverlay = ref;
        }}
        className={styles.coverOverlayText}
        style={{
          width: this.props.width ? this.props.width : '100%',
          left: '0',
        }}
      >
        <div
          className={styles.coverOverlayTextTop}
          style={{
            height: this.props.verticalWrap || 24,
          }}
        >
          {t(
            'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
          )}
        </div>

        {this.props.pageWidth / this.props.pageHeight < 2.8 ? (
          <div
            className={styles.coverOverlayTextSides}
            style={{
              display: 'flex',
              overflow: 'hidden',
              width: `calc(100% - ${this.props.outerAdjustment * 2}px)`,
            }}
          >
            {!this.props.hideLeft ? (
              <div
                className={styles.coverOverlayTextLeft}
                style={{
                  width: this.props.horizontalWrap || 24,
                  height: this.props.pageHeight,
                }}
              >
                {t(
                  'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
                )}
              </div>
            ) : (
              <div />
            )}
            <div
              className={styles.coverOverlayTextRight}
              style={{
                width: this.props.horizontalWrap || 24,
                height: this.props.pageHeight,
              }}
            >
              {t(
                'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
              )}
            </div>
          </div>
        ) : (
          <div />
        )}

        <div
          className={styles.coverOverlayTextBottom}
          style={{
            height: this.props.verticalWrap || 24,
          }}
        >
          {t(
            'ZONEOVERLAY.Safe area within dotted line. Pink areas may be lost in trimming and binding',
          )}
        </div>
      </div>
    );
  }
}

CoverOverlayText.propTypes = {
  width: PropTypes.number.isRequired,
  pageWidth: PropTypes.number.isRequired,
  pageHeight: PropTypes.number.isRequired,
  outerAdjustment: PropTypes.number,
  verticalWrap: PropTypes.number,
  horizontalWrap: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  wrap: Selectors.wrapSelector(state),
}))(CoverOverlayText);
